module.exports = __webpack_public_path__ + "static/img/course3.251008ba.png";